<template>
  <!-- 案件詳細 -->
  <div id="CORegistRequestDetail">
    <div id="item-contens">
      <div class="card-content margin-top">
        <span style="font-size:20px;">施設情報</span>
        <table>
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{institutionApplication.hospitalName}}</td></tr>
          <tr><th>診療科</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{institutionApplication.division}}</td></tr>
          <tr v-if="isDealer()"><th>担当支店</th><td>{{institutionApplication.office | officeFilter(branchList)}}</td></tr>
          <tr><th>郵便番号</th><td>{{institutionApplication.zip}}</td></tr>
          <tr><th>都道府県</th><td>{{institutionApplication.prefecture}}</td></tr>
          <tr><th>市町村</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{institutionApplication.city}}</td></tr>
          <tr><th>住所1</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{institutionApplication.address1}}</td></tr>
          <tr><th>住所2</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{institutionApplication.address2}}</td></tr>
          <tr><th>電話番号</th><td>{{institutionApplication.phoneNumber}}</td></tr>
          <tr><th>クライアント認証</th><td><template v-if="institutionApplication.clientAuthentication">有効にする</template><template v-else>有効にしない</template> </td></tr>
          <tr v-if="isDealer()"><th>フィリップス保守サービス</th><td><template v-if="institutionApplication.crossReference">有</template><template v-else>無</template></td></tr>
          <tr><th>備考</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{institutionApplication.biko}}</div></td></tr>
          <tr v-if="isDealer()"><td colspan="2">
              <b-checkbox class="cstmCheckBox" value="true" disabled></b-checkbox>申請者がケア オーケストレーター申込み行うことについて、該当医療機関の同意を取得しています。
            </td>
          </tr>
        </table>
      </div>
      <!-- ユーザー情報（医療施設）とユーザー情報（ディーラー）を結合して一覧に表示させる -->
      <div class="card-content margin-top" v-for="(user, index) in mergedUserInfoList" :key="index">
        <span style="font-size:20px;">ユーザー情報{{index + 1}}</span>
        <table>
          <tr><th>姓</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{user.familyName}}</td></tr>
          <tr><th>名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{user.firstName}}</td></tr>
          <tr v-if="isDealer()"><th>ユーザー区分</th><td>{{user.userClassification}}</td></tr>
          <tr><th>処方設定</th><td><template v-if="user.prescriptionSettings">操作可</template><template v-else>操作不可</template></td></tr>
          <tr><th>希望ユーザーID(第一希望)</th><td>{{user.userIDFirstChoice}}</td></tr>
          <tr><th>希望ユーザーID(第二希望)</th><td>{{user.userIDSecondChoice}}</td></tr>
          <tr><th>希望ユーザーID(第三希望)</th><td>{{user.userIDThirdChoice}}</td></tr>
          <tr><th>メールアドレス</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{user.mail}}</td></tr>
          <tr v-if="!isDealer()">
            <th>ケア　エクスポーター</th>
            <td>
              <template v-if="user.careExporter">利用する</template>
              <template v-else>利用しない</template>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
export default {
  name: "CORegistRequestDetail",
  props: {
    institutionApplication: Object,
    mergedUserInfoList: Array,
  },
  methods: {
    isDealer: function() {
      return this.roleId == this.role.role_dealer;
    },
  },
  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var branchList = this.getBranchOfficeMaster();
    const { roleId } = userInfo;
    branchList.unshift({});
    return {
      role,
      roleId,
      branchList,
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
};
</script>

<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/CORegistRequestDetail.vue